import React, { useContext, useState, useEffect, useRef } from "react"
import { AuthContext } from "../../context/AuthContext"
import {
    collection,
    query,
    addDoc,
    serverTimestamp,
    orderBy,
    onSnapshot,
    getDoc,
    doc,
    updateDoc,
    Timestamp
} from "firebase/firestore"
import { db } from "../../firebase"
import { NavLink, useLocation } from "react-router-dom"
import { handleNewMessageNotif } from "../../helpers/HelperFunctions"
import ChatRoomSkeleton from "./ChatRoomSkeleton"

const ChatRoom = ({chatroomId, setActiveChat, setThumbnailImage}) => {
    const location = useLocation()
    const chatId = location.pathname.split('/').at(-1)

    const [messages, setMessages] = useState([])
    const [typedMessage, setTypedMessage] = useState('')
    const [chatData, setChatData] = useState(null)
    // const [chatActive, setIsChatActive] = useState(null)
    const [listing, setListing] = useState(null)
    const [userPicture, setUserPicture] = useState("")
    const [chatroomLoading, setChatroomLoading] = useState(false)
    
    const { currentUser } = useContext(AuthContext)

    const chatroom = useRef({})
    // console.log(chatroom.current, "&&&&")
    // const listing = useRef({})
    const getUserPicture = async(userId) => {
        try {
            const userSnapshot = await getDoc(doc(db, "users", userId))
            const userInfo = userSnapshot.data()
            setUserPicture(userInfo.avatarUrl)
        } catch (err) {
            console.error(err.message)
        }
    }

    const fetchChatandListingData = async () => {
        console.log("fetching chat and listing data")
        // setListing(null) //reloads listing so there navlink is reset instead of staying with old one
        if (chatroomId) {
            setChatroomLoading(true)
            try{
                try {
                    await getDoc(doc(db, "chatrooms", chatroomId))
                    .then((res) => {
                        chatroom.current = res.data()
                        console.log(chatroom.current)
                        // setIsChatActive(chatroom.current.active)
                        setChatData(chatroom.current)
                    })
                } catch(err) {
                    console.error(err.message)
                }
    
                try {
                    await getDoc(doc(db, "listings", chatroom.current.listingId))
                    .then((res => {
                        if (res.data()) {
                            setListing(res.data())
                            console.log(res.data())
                            setThumbnailImage(res.data().image_urls[0])
                            console.log(res.data().image_urls[0])
                        } 
                        else {
                            setListing(null)
                        }
                    }))
                } catch(err) {
                    console.error(err.message)
                }
    
                chatroom.current.to.uid === currentUser.uid ?
                await getUserPicture(chatroom.current.from.uid) :
                await getUserPicture(chatroom.current.to.uid)
            } finally {
                setChatroomLoading(false)
            }
        }   
    }
    //***TODO: use this to not fetch listings data if chat is not active
    // useEffect(() => {
    //     if (chatActive) {
    //         console.log("asdfasdf")
    //         getDoc(doc(db, "listings", chatroom.current.listingId))
    //         .then((res => {
    //             if (res.data()) {
    //                 setListing(res.data())
    //             } else {
    //                 setListing({})
    //             }
    //         }))
    //     }
    // }, [chatroomId])

    const messagesRef = collection(db, `chatrooms/${chatroomId}/messages`)
    
    useEffect(() => {
        fetchChatandListingData()
        
        const queryMessages = query(
            messagesRef, 
            orderBy("createdAt")
            )
            
        if(chatroomId) {
            const unsubscribe = 
                onSnapshot(queryMessages, (snapshot) => {
                    const messageArray = []
    
                    snapshot.forEach((doc) => {
                        messageArray.push({...doc.data(), id: doc.id})
                    })
                    if (!messageArray[messageArray.length-1].createdAt) {
                        messageArray[messageArray.length-1].createdAt = Timestamp.now()
                    }
                    console.log(messageArray)
                    setMessages(messageArray)
                })
    
            return () => unsubscribe()
        }
    }, [chatroomId])

    // const messages = getDocs(collection(db, 'messages'))
    // console.log('messages', messages)
    // const sortedMessages = messagesRef.orderBy('createdAt').limit(25)
    // const [messages] = useCollectionData(query, { idField: 'id'})

    // const getMessages = async() => {
    //     try {
    //         const messagesRef = await collection(db, "messages")
    //         const q = query(messagesRef, orderBy("createdAt"))
    //         // const [messages] = useCollectionData(query, { idField: "id"})
    //         console.log(q)
    //         const querySnapshot = await getDocs(q)
    //         const queryRes = []
    //         querySnapshot.forEach((message) => {
    //             const messageData = message.data()
    //             messageData.message_id = message.id
    //             console.log(messageData)
    //             queryRes.push(messageData)
    //         })
    //         setMessages(queryRes)
    //         console.log('messages',queryRes)
    //     } catch(err) {
    //         console.error(err.message)
    //     }
    // }

    // useEffect(() => {
    //     getMessages()
    // }, [])

    // const sendMessage = async (chatroomId) => {
    //     await addDoc(
    //         collection(db, `chatroom/${chatroomId}/messages`),
    //         {
    //             chatroomId: chatroomId,
    //             listingId: listing.listing_id,
    //             message: message
    //         }
    //     )
    // }

    // const createNewChat = async () => {
    //     await addDoc(
    //         collection(db, "chatroom"),
    //         {
    //             listingId: listing.listing_id,
    //             to: listing.user,
    //             from: currentUser.email
    //         }
    //     ).then(e => {
    //         console.log(e.id)
    //         sendMessage(e.id)
    //     })
    //     console.log(message)
    // }

    const onSubmitForm = async(e) => {
        e.preventDefault()
        if (typedMessage.replace(/\s/g,'').length) {
            try{
                const time = serverTimestamp()
                await addDoc(
                    collection(db, `chatrooms/${chatroomId}/messages`),
                    {
                        sender: {
                            email: currentUser.email,
                            uid: currentUser.uid,
                            firstName: currentUser.firstName
                        },
                        message: typedMessage,
                        createdAt: time
                    }
                )
                await updateDoc(doc(db, "chatrooms", chatroomId),{
                    lastActive: time,
                    lastSender: currentUser.uid,
                    unread: true
                })
    
                const timestamp = Timestamp.now()
                setMessages(messages.concat([{
                    sender: {
                        email: currentUser.email,
                        uid: currentUser.uid,
                        firstName: currentUser.firstName
                    },
                    message: typedMessage,
                    createdAt: timestamp
                }]))
                setTypedMessage('')
                console.log(typedMessage)
                const messageObj = {
                    recipientId : chatData.from.uid === currentUser.uid ? chatData.to.uid : chatData.from.uid,
                    senderName: currentUser.firstName,
                    message: typedMessage
                }
                await handleNewMessageNotif(messageObj)
                // await addDoc(
                //     // collection(db, "messages"), 
                //     // {
                //     //     message: message,
                //     //     sender: currentUser.email,
                //     //     receiver: listing.user,
                //     //     listingId: listing.listing_id,
                //     //     createdAt: serverTimestamp()
                //     // }
                //     collection(db, "chatrooms"),
                //     {
                //         listingId: listing.listing_id,
                //         message: "asdf"
                //     }
                // ).then(e => {
                //     console.log(e.id)
                //     addDoc(
                //         collection(db, `chatrooms/${e.id}/messages`),
                //         {
                //             listingId: listing.listing_id,
                //             message: message
                //         }
                //     )
                // })
                // console.log("Message sent", docRef.id)
                
            } catch(err) {
                console.log(err)
            }
        }
    }

    const onClose = () => {
        // setIsChatActive(null)
        setChatData(null)
        setActiveChat(null)
    }

    const ScrollToBottom = () => {
        const elementRef = useRef()
        useEffect(() => elementRef.current.scrollIntoView())
        return <div ref={elementRef}/>
    }

    // const navigate = useNavigate()
    // const handleClick = () => {
    //     navigate(`/item/${listing.id}`, {state:{listing_id: listing.id}})
    // }

    // if (chatActive === null) return null
    if (chatroomLoading === true) return <ChatRoomSkeleton/>
    if (chatData === null) return null
    return (
        <div className="chat-container">
            <button className="btn-close"onClick={onClose}/>

            {/* { chatActive && listing !== null ?  */}
            { chatData.active && listing !== null ? 
                <NavLink className="listing-link-container"
                    to={{pathname: `/item/${listing.id}`,}}
                    // state= {{listing_id: listing.listing_id}}
                    // onClick={handleClick}
                >
                {/* <div 
                className="listing-link-container" 
                    onClick={handleClick}
                > */}
                    <div className="listing-link-thumbnail-container">
                        <img className="listing-link-thumbnail" src={listing.image_urls ? listing.image_urls[0] : null}/>
                    </div>
                    <div className="listing-link-info-container">
                        {/* <div className="listing-owner">{listing.user ? listing.user.firstName : null}</div> */}
                        <div className="listing-title">{listing.title}</div>
                        <div className="listing-price">${listing.price}</div>
                        <div className="listing-condition">{listing.condition}</div>
                    </div>
                </NavLink> :
                <div 
                className="listing-link-container"
                style={{"background": "gray", "cursor": "auto"}}
                >
                    <div className="listing-link-thumbnail-container">
                        {/* <img className="listing-link-thumbnail" src={listing.image_urls ? listing.image_urls[0] : null}/> */}
                        <img className="listing-link-thumbnail" />
                    </div>
                    <div className="listing-link-info-container">
                        {/* <div className="listing-owner">{listing.user ? listing.user.firstName : null}</div> */}
                        <div className="listing-title">{listing}</div>
                        <div className="listing-price">${listing}</div>
                        <div className="listing-condition">{listing}</div>
                        {/* <div className="listing-title">{listing.title}</div>
                        <div className="listing-price">${listing.price}</div>
                        <div className="listing-condition">{listing.condition}</div> */}
                    </div>
                </div>
            }
            <div className="chatroom-chat-with">{listing && listing.user.userId === currentUser.uid ? 
            // <div className="chatroom-chat-with">{listing.user && listing.user.userId === currentUser.uid ? 
                `Selling to ${chatroom.current.from.firstName}`: 
                `Buying from ${chatroom.current.to.firstName}`}</div>
            
            <div  className="chat-div">
                {messages && messages.map((msg, i) => {
                    if (msg.sender.uid === currentUser.uid) {
                        return(
                            <React.Fragment>
                            {
                                (i === 0 || msg.createdAt.toDate().toDateString() !== messages[i-1].createdAt.toDate().toDateString()) && 
                                (<div className="chat-date-header">{msg.createdAt.toDate().toDateString()}</div>)
                            }
                        
                            <div className="message message-sent" key={i}>
                                <span key={msg.id} className="chatmessage sent">
                                    <span className="message-text">{msg.message}</span>
                                    <span className="message-time">
                                        {msg.createdAt.toDate().toLocaleTimeString([],{hour: 'numeric', minute: '2-digit', hour12: true})}
                                    </span>
                                </span>
                                {currentUser.avatarUrl ?
                                    <img src={currentUser.avatarUrl} className="avatar item-display-avatar message-avatar"/> :
                                    <span className="material-icons avatar item-display-avatar message-avatar">account_circle</span>
                                }
                            </div>
                            </React.Fragment>
                        )
                    } else {
                        return(
                            <React.Fragment>
                            {
                                (i === 0 || msg.createdAt.toDate().toDateString() !== messages[i-1].createdAt.toDate().toDateString()) && 
                                (<div className="chat-date-header">{msg.createdAt.toDate().toDateString()}</div>)
                            }
                            <div className="message message-received" key={i}>
                                {userPicture ?
                                    <NavLink
                                    to={{
                                        pathname: `/user/${chatroom.current.from.uid === currentUser.uid ? chatroom.current.to.uid : chatroom.current.from.uid}`,
                                    }}>
                                        <img src={userPicture} className="avatar item-display-avatar message-avatar"/>
                                    </NavLink>:
                                    <NavLink
                                    to={{
                                        pathname: `/user/${chatroom.current.from.uid === currentUser.uid ? chatroom.current.to.uid : chatroom.current.from.uid}`,
                                    }}>
                                        <span className="material-icons avatar item-display-avatar message-avatar">account_circle</span>
                                    </NavLink>
                                }
                                <span key={msg.id} className="chatmessage received">
                                    <span className="message-text">{msg.message}</span>
                                    <span className="message-time">
                                        {msg.createdAt.toDate().toLocaleTimeString([],{hour: 'numeric', minute: '2-digit', hour12: true})}
                                    </span>
                                </span>
                            </div>
                            </React.Fragment>
                        )
                    }
                })}
                <ScrollToBottom />
            </div>
            {/* {chatActive && listing !== null ? */}
            {chatData.active && listing !== null ?
                <form className="chat-form" onSubmit={onSubmitForm}>
                    <input 
                        value={typedMessage}
                        type="text"    
                        className="form-control chat-input"
                        onChange={
                            e => setTypedMessage(e.target.value)
                        }
                    />
                    <input type="submit" value="Send" className="btn btn-success"/> 
                </form> :
                <form>
                    <input 
                        disabled
                        className="form-control chat-input"
                        value="This listing has been archived or deleted"
                        type="text"    
                    />
                </form>
            }
        </div>
    )
}

export default ChatRoom